import React from "react";
import {
  Box,
  CssBaseline,
  ThemeProvider,
  // useMediaQuery,
} from "@mui/material";
import theme from "../../contexts/providers/theme";
import useDashboardData from "../../hooks/useDashboardData";
import SummaryCards from "../../components/dashboard/SummaryCard";
import DashboardLayout from "../../components/dashboard/DashboardLayout";
import FastMovers from "../../components/dashboard/FastMovers";
import PrioritySection from "../../components/dashboard/PrioritySection";
import SlowMovers from "../../components/dashboard/SlowMovers";
import DeadStock from "../../components/dashboard/DeadStock";
import LikelyDeadSoonSection from "../../components/dashboard/LikelyDeadSection";

export default function Dashboard() {

  // const isXs = useMediaQuery(theme.breakpoints.down("sm"));
  // const isMdDown = useMediaQuery(theme.breakpoints.down("md"));

  const {
    data,
    meta,
  } = useDashboardData();

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />

      <DashboardLayout metaData={meta} showHeader={true}>
        <SummaryCards items={data?.big_numbers_section?.items} />
        <PrioritySection data={data?.priority_section?.priority_actions} />
        <Box sx={{margin: "1rem 0"}} id="dead-stock-section">
          <DeadStock data={data?.dead_stock_section?.items} />
        </Box>
        <Box id="likely-dead-soon-section">
          <LikelyDeadSoonSection data={data?.likely_dead_soon_section} />
        </Box>
       
        <Box id="slow-movers-section">
          <SlowMovers data={data?.slow_movers_section?.items} />
        </Box>
        <Box id="fast-movers-section" sx={{margin: '1rem 0'}}>
          <FastMovers data={data?.fast_movers_section?.items} />
        </Box>
        
      </DashboardLayout>
    </ThemeProvider>
  );
}